import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { Breadcrumbs } from '../../../AbstractElements'
import HomeTestProfileList from './HomeTestProfileList'
import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";


export default function TestProfileList() {
  const { t } = useTranslation();
  return (
    <Fragment>
      <Breadcrumbs mainTitle={t("List Of Lab Report Test Profile")} parent={t("Home")} title={t("List Of Lab Report Test Profile")} />
      <Container fluid={true}>
        <Row>
          <Col className="h-100">
            <HomeTestProfileList />
          </Col>
        </Row>
      </Container>    
    </Fragment>
  )
}
